var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


if (typeof $cfae44f0dfdf62c0$exports === 'undefined') window.process = {
    env: {}
};
const $c1ce9d969bfa6909$var$TMDB_TOKEN = "eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI4NWJhMmZkZDIxNDZmOTVmYWUwMjFkOGVjM2JkYjBlZCIsIm5iZiI6MTczOTM1OTY1Ny4wNjgsInN1YiI6IjY3YWM4NWE5NDcwNTFjNTRiZWIwZGIyOCIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.c1eElgFPFvmsLhjMVEox6oHTR-7L58UbWENkWLz8O-A";
console.log("All available env vars:", $cfae44f0dfdf62c0$exports.env);
// import 'dotenv/config';
// const TMDB_TOKEN = process.env.THEMOVIEDB_BEARER_TOKEN;
//Base URLS
const $c1ce9d969bfa6909$var$image_url = 'https://image.tmdb.org/t/p';
const $c1ce9d969bfa6909$var$poster_baseURL = `${$c1ce9d969bfa6909$var$image_url}/w300`; //consider other widths
const $c1ce9d969bfa6909$var$backdrop_baseURL = `${$c1ce9d969bfa6909$var$image_url}/original`;
const $c1ce9d969bfa6909$var$vidscr_baseURL = 'https://vidsrc.net/embed/';
const $c1ce9d969bfa6909$var$searchModalBtn = document.getElementById('search_modal_btn');
const $c1ce9d969bfa6909$var$closeSearchModal = document.getElementById('close_modal_btn');
const $c1ce9d969bfa6909$var$searchResultsContainer = document.getElementById('search_results_container');
const $c1ce9d969bfa6909$var$homePage = document.getElementById('home_page');
const $c1ce9d969bfa6909$var$playPage = document.getElementById('play_page');
const $c1ce9d969bfa6909$var$backHome = document.getElementById("back_home");
const $c1ce9d969bfa6909$var$videoContainer = document.getElementById('video_player');
const $c1ce9d969bfa6909$var$creditsContainer = document.getElementById('results');
let $c1ce9d969bfa6909$var$slideIndex = 0;
const $c1ce9d969bfa6909$var$options = {
    method: 'GET',
    headers: {
        accept: 'application/json',
        Authorization: `Bearer ${$c1ce9d969bfa6909$var$TMDB_TOKEN}`
    }
};
window.addEventListener('scroll', ()=>{
    const header = document.querySelector('.header');
    if (window.scrollY > 50) header.classList.add('scrolled');
    else header.classList.remove('scrolled');
});
// show homepage or  play page as the user interacts 
$c1ce9d969bfa6909$var$backHome.addEventListener('click', ()=>{
    $c1ce9d969bfa6909$var$homePage.style.display = "block";
    $c1ce9d969bfa6909$var$playPage.style.display = "none";
    $c1ce9d969bfa6909$var$videoContainer.innerHTML = '';
});
//first call to get content
const $c1ce9d969bfa6909$var$getContentInfo = async function(url, type) {
    const response = await fetch(url, $c1ce9d969bfa6909$var$options);
    const data = await response.json();
    // console.log(data.results);
    return data.results.map((el)=>{
        return {
            type: type,
            title: type === 'movie' ? el.original_title : el.name,
            poster: `${$c1ce9d969bfa6909$var$poster_baseURL}${el.poster_path}`,
            rating: `${Math.round(el.vote_average)}/10`,
            id: el.id,
            backdrop: `${$c1ce9d969bfa6909$var$backdrop_baseURL}${el.backdrop_path}`,
            poplarity: el.popularity,
            vote_average: el.vote_average,
            date: type === 'TV' ? el.first_air_date : el.release_date
        };
    });
};
//call to get details 
const $c1ce9d969bfa6909$var$getContentDetails = async function(id, type) {
    try {
        if (type === 'movie') {
            const details = await $c1ce9d969bfa6909$var$getMovieDetails(id);
            const credits = await $c1ce9d969bfa6909$var$getMovieCredits(id);
            const similar = await $c1ce9d969bfa6909$var$getSimilarMovies(id);
            return {
                type: type,
                title: details.title,
                genres: details.genre_names,
                release_date: details.release_date,
                rating: `${Math.round(details.vote_average)}/10`,
                overview: details.overview,
                credits: credits.cast.slice(0, 5).map((actor)=>({
                        actor: actor.name,
                        image: `${$c1ce9d969bfa6909$var$poster_baseURL}${actor.profile_path}`
                    })),
                poster: `${$c1ce9d969bfa6909$var$poster_baseURL}${details.poster_path}`,
                backdrop: `${$c1ce9d969bfa6909$var$backdrop_baseURL}${details.backdrop_path}`,
                imdb_id: details.imdb_id,
                id: details.id,
                original_language: details.original_language,
                runtime: `${details.runtime} mins`,
                similar: similar.map((sim)=>sim.title),
                production: details.production_companies,
                country: details.production_countries,
                vidSrc: `${$c1ce9d969bfa6909$var$vidscr_baseURL}${details.imdb_id}`
            };
        }
        if (type === 'TV') {
            const details = await $c1ce9d969bfa6909$var$getTvDetails(id);
            const credits = await $c1ce9d969bfa6909$var$getTvCredits(id);
            // Fetch season details with episode data
            const season_details = await Promise.all(details.seasons.map(async (season)=>{
                const seasonData = await $c1ce9d969bfa6909$var$getTvSeasonDetails(id, season.season_number);
                return {
                    season_number: season.season_number,
                    episodes: seasonData.episodes.map((ep)=>({
                            ep_air_date: ep.air_date,
                            ep_name: ep.name,
                            ep: ep.episode_number,
                            ep_source: `${$c1ce9d969bfa6909$var$vidscr_baseURL}tv/${id}/${season.season_number}/${ep.episode_number}`
                        }))
                };
            }));
            return {
                type: type,
                title: details.name,
                genres: details.genres.map((genre)=>genre.name),
                original_air_date: details.first_air_date,
                rating: `${Math.round(details.vote_average)}/10`,
                overview: details.overview,
                credits: credits.cast.slice(0, 5).map((actor)=>({
                        actor: actor.name,
                        image: `${$c1ce9d969bfa6909$var$poster_baseURL}${actor.profile_path}`
                    })),
                poster: `${$c1ce9d969bfa6909$var$poster_baseURL}${details.poster_path}`,
                backdrop: `${$c1ce9d969bfa6909$var$backdrop_baseURL}${details.backdrop_path}`,
                imdb_id: details.external_ids?.imdb_id || 'N/A',
                id: details.id,
                original_language: details.original_language,
                seasons: details.seasons.map((season)=>({
                        season_number: season.season_number,
                        episodes: season.episode_count,
                        poster: `${$c1ce9d969bfa6909$var$backdrop_baseURL}${season.poster_path}`
                    })),
                production: details.production_companies.map((el)=>el.name),
                country: details.origin_country,
                episode_details: season_details
            };
        }
    } catch (error) {
        console.log(error);
        return [];
    }
};
/*************************************************************************************************************************************************************** */ //Helper Functions
const $c1ce9d969bfa6909$var$getTvSeasonDetails = async (tvId, seasonNumber)=>{
    try {
        const response = await fetch(`https://api.themoviedb.org/3/tv/${tvId}/season/${seasonNumber}`, $c1ce9d969bfa6909$var$options);
        if (!response.ok) throw new Error(`Failed to fetch season details for TV ID: ${tvId}, Season: ${seasonNumber}`);
        return await response.json();
    } catch (error) {
        console.error(`Error fetching season details:`, error);
        return {
            episodes: []
        }; // Return empty episodes in case of failure
    }
};
const $c1ce9d969bfa6909$var$fetchTMDBData = async (url)=>{
    try {
        const response = await fetch(url, $c1ce9d969bfa6909$var$options);
        if (!response.ok) throw new Error(`Failed to fetch: ${url}`);
        return await response.json();
    } catch (error) {
        console.error(error);
        return null;
    }
};
const $c1ce9d969bfa6909$var$getMovieDetails = async (tmdbId)=>{
    const url = `https://api.themoviedb.org/3/movie/${tmdbId}?language=en-US`;
    const data = await $c1ce9d969bfa6909$var$fetchTMDBData(url);
    return data ? {
        imdb_id: data.imdb_id,
        genre_names: data.genres.map((el)=>el.name),
        runtime: data.runtime,
        production_companies: data.production_companies.map((el)=>el.name),
        production_countries: data.production_countries.map((el)=>el.iso_3166_1),
        title: data.title,
        id: data.id,
        original_language: data.original_language,
        overview: data.overview,
        release_date: data.release_date,
        backdrop_path: data.backdrop_path,
        vote_average: data.vote_average
    } : {};
};
const $c1ce9d969bfa6909$var$getMovieCredits = async (tmdbId)=>{
    const url = `https://api.themoviedb.org/3/movie/${tmdbId}/credits?language=en-US`;
    return await $c1ce9d969bfa6909$var$fetchTMDBData(url) || {
        cast: []
    };
};
const $c1ce9d969bfa6909$var$getSimilarMovies = async (tmdbId)=>{
    const url = `https://api.themoviedb.org/3/movie/${tmdbId}/similar?language=en-US&page=1`;
    return (await $c1ce9d969bfa6909$var$fetchTMDBData(url))?.results || [];
};
const $c1ce9d969bfa6909$var$getTvDetails = async (tmdbId)=>{
    const url = `https://api.themoviedb.org/3/tv/${tmdbId}?language=en-US`;
    return await $c1ce9d969bfa6909$var$fetchTMDBData(url) || {};
};
const $c1ce9d969bfa6909$var$getTvCredits = async (tmdbId)=>{
    const url = `https://api.themoviedb.org/3/tv/${tmdbId}/credits?language=en-US`;
    return await $c1ce9d969bfa6909$var$fetchTMDBData(url) || {
        cast: []
    };
};
/*************************************************************************************************************************************************************** */ // Search Functionality
const $c1ce9d969bfa6909$var$searchTerm = document.getElementById('search-term');
const $c1ce9d969bfa6909$var$addSearchParam = function(link, keyword) {
    keyword = keyword.replaceAll(/ /g, '%'); // replace any spaces in keyword with % - more efficent
    link = link.replace(`${link.substring(link.indexOf('q'), link.indexOf('&'))}`, `query=${keyword}` //replace anything that comes between q and & with query=${keyword}
    );
    return link;
};
const $c1ce9d969bfa6909$var$searchMedia = async function(keyword) {
    try {
        const movies = await $c1ce9d969bfa6909$var$getContentInfo($c1ce9d969bfa6909$var$addSearchParam(`https://api.themoviedb.org/3/search/movie?query=&include_adult=false&language=en-US&page=1`, keyword), 'movie');
        const tv = await $c1ce9d969bfa6909$var$getContentInfo($c1ce9d969bfa6909$var$addSearchParam(`https://api.themoviedb.org/3/search/tv?query=&include_adult=false&language=en-US&page=1`, keyword), 'TV');
        const results = await Promise.all([
            ...movies.sort((a, b)=>b.date - a.date).filter((el, i)=>i < 7),
            ...tv.sort((a, b)=>b.date - a.date).filter((el, i)=>i < 7)
        ]);
        const sorted = results.map((el)=>el).sort((a, b)=>b.vote_average - a.vote_average);
        return sorted.sort((a, b)=>b.poplarity - a.poplarity).filter((el, i)=>i < 7); // if number of keyword is less than 5 don't get anything from origin east - JP, KR
    } catch (error) {
        console.error(error);
        return [];
    }
};
const $c1ce9d969bfa6909$var$debounce = function(callback, delay) {
    let timer = null;
    return function(...args) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(function() {
            callback(...args);
        }, delay);
    };
};
const $c1ce9d969bfa6909$var$debouncedSearch = $c1ce9d969bfa6909$var$debounce((e)=>{
    const searchTermHTML = document.getElementById('search_results');
    searchTermHTML.innerHTML = '';
    $c1ce9d969bfa6909$var$searchMedia(e.target.value).then((res)=>{
        res.forEach((el)=>{
            const movieCard = document.createElement('div');
            movieCard.classList.add('movie-card');
            movieCard.innerHTML = `
                 <img src="${el.poster}" alt="${el.title} poster">
                    <div class="movie-info">
                        <span class="movie-title">${el.title}</span>
                        <div class="movie-details">.
                            <span class="type">${el.type}</span>
                            <div class="rating">
                                <span>${el.rating}</span>
                            </div>
                        </div>
                    </div>
            `;
            // Add click event listener to each movie card
            movieCard.addEventListener('click', async ()=>{
                const details = await $c1ce9d969bfa6909$var$getContentDetails(el.id, el.type);
                if (el.type === 'movie') $c1ce9d969bfa6909$var$renderMovie(details);
                else if (el.type === 'TV') $c1ce9d969bfa6909$var$renderTv(details);
                $c1ce9d969bfa6909$var$renderCredits(details);
                $c1ce9d969bfa6909$var$homePage.style.display = "none";
                $c1ce9d969bfa6909$var$playPage.style.display = "block";
            });
            searchTermHTML.appendChild(movieCard); // Append the created element
        });
    }); // renderSearch
}, 500);
if ($c1ce9d969bfa6909$var$searchTerm) $c1ce9d969bfa6909$var$searchTerm.addEventListener('input', $c1ce9d969bfa6909$var$debouncedSearch);
else alert(`Movie/ TV show not found`);
$c1ce9d969bfa6909$var$searchModalBtn.addEventListener('click', ()=>{
    $c1ce9d969bfa6909$var$searchResultsContainer.style.display = "block";
    $c1ce9d969bfa6909$var$searchTerm.focus();
});
$c1ce9d969bfa6909$var$closeSearchModal.addEventListener('click', ()=>{
    $c1ce9d969bfa6909$var$searchResultsContainer.style.display = "none";
});
/*************************************************************************************************************************************************************** */ // Generic movie tile can be called to render in any container e.g. Popular movies, TOP movies, TOP TV, search results et al
const $c1ce9d969bfa6909$var$renderResults = function(el, string) {
    const tile = ` <div class="movie-card" id="${el.id}" data-type="${el.type}">
                    <img src="${el.poster}" alt="${el.title} poster">
                    <div class="movie-info">
                        <span class="movie-title">${el.title}</span>
                        <div class="movie-details">
                            <span class="type">${el.type}</span>
                            <div class="rating">
                                <span>${el.rating}</span>
                            </div>
                        </div>
                    </div>
                </div>`;
    const container = document.getElementById(string);
    container.insertAdjacentHTML('beforeend', tile);
};
const $c1ce9d969bfa6909$var$topRatedMovies = $c1ce9d969bfa6909$var$getContentInfo('https://api.themoviedb.org/3/movie/top_rated?language=en-US&page=1', 'movie').then((data)=>{
    // console.log(data);
    data.forEach((el)=>{
        $c1ce9d969bfa6909$var$renderResults(el, 'topRatedMovies');
    });
});
const $c1ce9d969bfa6909$var$topMovies = $c1ce9d969bfa6909$var$getContentInfo('https://api.themoviedb.org/3/movie/popular?language=en-US&page=1', 'movie').then((data)=>{
    data.forEach((el)=>{
        $c1ce9d969bfa6909$var$renderResults(el, 'popular');
    });
});
const $c1ce9d969bfa6909$var$popularTvSeries = $c1ce9d969bfa6909$var$getContentInfo('https://api.themoviedb.org/3/tv/popular?language=en-US&page=1', 'TV').then((data)=>{
    data.forEach((el)=>{
        $c1ce9d969bfa6909$var$renderResults(el, "popularTvSeries");
    });
});
const $c1ce9d969bfa6909$var$topTvSeries = $c1ce9d969bfa6909$var$getContentInfo('https://api.themoviedb.org/3/tv/top_rated?language=en-US&page=1', 'TV').then((data)=>{
    data.forEach((el)=>{
        $c1ce9d969bfa6909$var$renderResults(el, 'topRatedSeries');
    });
});
// start search here
// search helper functions
//function to add query parameters to a search url
// searchMedia('house').then(data => data);
// searchMedia('house').then(data => console.log(data));
//TODO - replace query selector for search input 
// const searchContainer = document.querySelector('#search-term');
// searchContainer.addEventListener('input', debouncedSearch);
// this function will take in a search result object either from an an array or else and the second param is a container where the results are to be displayed
//
const $c1ce9d969bfa6909$var$popularMov = document.getElementById('popular');
const $c1ce9d969bfa6909$var$topRatedMov = document.getElementById('topRatedMovies');
const $c1ce9d969bfa6909$var$topRatedSeries = document.getElementById('topRatedSeries');
const $c1ce9d969bfa6909$var$popularSeries = document.getElementById('popularTvSeries');
//event listener to get details when a user clicks on a tile
// also to be used to render details onto the play page
// handles what happens when a movie or slider card is clicked 
const $c1ce9d969bfa6909$var$handleContentClick = async (e)=>{
    const id = e.target.parentNode.id;
    const type = e.target.parentNode.dataset.type;
    const movieData = await $c1ce9d969bfa6909$var$getContentDetails(id, type);
    $c1ce9d969bfa6909$var$homePage.style.display = 'none';
    $c1ce9d969bfa6909$var$playPage.style.display = "block";
    console.log(movieData);
    if (movieData.type === 'movie') $c1ce9d969bfa6909$var$renderMovie(movieData);
    else if (movieData.type === 'TV') $c1ce9d969bfa6909$var$renderTv(movieData);
    $c1ce9d969bfa6909$var$renderCredits(movieData);
};
// renders the credits of movie or tv show clicked
function $c1ce9d969bfa6909$var$renderCredits(data) {
    $c1ce9d969bfa6909$var$creditsContainer.innerHTML = '';
    data.credits.forEach((credit)=>{
        const creditDiv = document.createElement('div');
        creditDiv.classList.add('credits_div');
        const imgEl = document.createElement('img');
        imgEl.classList.add('prof_pic');
        imgEl.src = `${credit.image}`;
        const nameEl = document.createElement('p');
        nameEl.classList.add('actor_name');
        nameEl.textContent = credit.actor;
        creditDiv.appendChild(imgEl);
        creditDiv.appendChild(nameEl);
        $c1ce9d969bfa6909$var$creditsContainer.appendChild(creditDiv);
    });
}
// renders the movie player and credits
function $c1ce9d969bfa6909$var$renderMovie(movie) {
    $c1ce9d969bfa6909$var$videoContainer.innerHTML = `
        <iframe class="iframe" allowfullscreen=true frameBorder="0" src="${movie.vidSrc}" width="100%" height="800"></iframe>
        <h2">${movie.title}</h2>
    `;
}
// renders tv shows episodes with seasons and episode and credits
function $c1ce9d969bfa6909$var$renderTv(tv) {
    $c1ce9d969bfa6909$var$videoContainer.innerHTML = `
        <iframe id="tvPlayer" class="iframe" allowfullscreen=true src="${tv.vidSrc}" width="100%" height="800"></iframe>
        <h2>${tv.title}</h2>
		<div class="controls container">
			<div id="seasonContainer" class="season_container"></div>
			<div id="episodeContainer" class="episodes_container"></div>
		</div>
    `;
    const iframe = document.getElementById('tvPlayer');
    const seasonContainer = document.getElementById('seasonContainer');
    seasonContainer.innerHTML = '';
    // tv.episode_details.forEach(season => {
    //     const seasonBtn = document.createElement('button');
    //     seasonBtn.classList.add('season_button');
    //     seasonBtn.textContent = `S0${season.season_number}`;
    //     seasonBtn.addEventListener('click', () => renderEpisodes(season.episodes, iframe));
    //     seasonContainer.appendChild(seasonBtn);
    // })
    const seasonSelect = document.createElement('select');
    seasonSelect.classList.add('season_select');
    seasonContainer.appendChild(seasonSelect);
    tv.episode_details.forEach((season)=>{
        const option = document.createElement('option');
        option.value = season.season_number;
        option.textContent = `S${season.season_number.toString().padStart(2, '0')}`;
        seasonSelect.appendChild(option);
    });
    seasonSelect.addEventListener('change', ()=>{
        const selectedSeasonNumber = parseInt(seasonSelect.value);
        const selectedSeason = tv.episode_details.find((season)=>season.season_number === selectedSeasonNumber);
        if (selectedSeason) $c1ce9d969bfa6909$var$renderEpisodes(selectedSeason.episodes, iframe);
    });
    if (tv.episode_details.length > 0) {
        seasonSelect.value = tv.episode_details[0].season_number;
        $c1ce9d969bfa6909$var$renderEpisodes(tv.episode_details[0].episodes, iframe);
    }
}
//helper funcion that rednders episodes in each season
function $c1ce9d969bfa6909$var$renderEpisodes(episodes, iframe) {
    const episodeContainer = document.getElementById('episodeContainer');
    episodeContainer.innerHTML = '';
    episodes.forEach((episode)=>{
        const epKey = `watched_S${episode.ep_name.toString().padStart(2, '0')}`;
        const epDiv = document.createElement('div');
        epDiv.classList.add('episode');
        if (localStorage.getItem(epKey)) epDiv.classList.add('watched');
        epDiv.textContent = `Episode ${episode.ep}: ${episode.ep_name}`;
        epDiv.addEventListener('click', ()=>{
            iframe.src = episode.ep_source;
            localStorage.setItem(epKey, true);
            epDiv.classList.add('watched');
        });
        episodeContainer.appendChild(epDiv);
    });
    if (episodes.length > 0) iframe.src = episodes[0].ep_source;
}
$c1ce9d969bfa6909$var$popularMov.addEventListener('click', $c1ce9d969bfa6909$var$handleContentClick);
$c1ce9d969bfa6909$var$topRatedMov.addEventListener('click', $c1ce9d969bfa6909$var$handleContentClick);
$c1ce9d969bfa6909$var$topRatedSeries.addEventListener('click', $c1ce9d969bfa6909$var$handleContentClick);
$c1ce9d969bfa6909$var$popularSeries.addEventListener('click', $c1ce9d969bfa6909$var$handleContentClick);
// home carousel section
// const showSlides = () => {
// 	const slides = document.querySelectorAll('#slider .slider');
// 	for (let i = 0; i < slides.length; i++) {
// 		slides[i].style.display = "none";
// 	}
// 	slideIndex++;
// 	if (slideIndex > slides.length) { slideIndex = 1; }
// 	slides[slideIndex - 1].style.display = "block";
// 	setTimeout(showSlides, 7000);
// };
const $c1ce9d969bfa6909$var$getCarouselData = async function() {
    try {
        const movies = await $c1ce9d969bfa6909$var$getContentInfo('https://api.themoviedb.org/3/movie/now_playing?language=en-US&page=1', 'movie');
        const tv = await $c1ce9d969bfa6909$var$getContentInfo('https://api.themoviedb.org/3/tv/airing_today?language=en-US&page=1', 'TV');
        const results = await Promise.all([
            ...movies,
            ...tv
        ]);
        return results;
    } catch (error) {
        console.error(error);
        return [];
    }
};
$c1ce9d969bfa6909$var$getCarouselData().then((data)=>{
    data.sort((a, b)=>b.poplarity - a.poplarity);
    const sliderContainer = document.getElementById("slider");
    sliderContainer.innerHTML = "";
    data.forEach((slide)=>{
        const slideItem = document.createElement('div');
        slideItem.classList.add('swiper-slide');
        slideItem.innerHTML = `
                    <img src="${slide.backdrop}" alt="movie/series backrop">
                    <div class="content">
                        <h2>${slide.title}</h2>
                        <p>- ${slide.rating} -</p>  
                    </div>
        `;
        slideItem.addEventListener('click', async ()=>{
            const details = await $c1ce9d969bfa6909$var$getContentDetails(slide.id, slide.type);
            if (slide.type === 'movie') $c1ce9d969bfa6909$var$renderMovie(details);
            else if (slide.type === 'TV') $c1ce9d969bfa6909$var$renderTv(details);
            $c1ce9d969bfa6909$var$renderCredits(details);
            $c1ce9d969bfa6909$var$homePage.style.display = "none";
            $c1ce9d969bfa6909$var$playPage.style.display = "block";
            console.log(details.title);
        });
        sliderContainer.appendChild(slideItem);
    });
// showSlides();
});
const $c1ce9d969bfa6909$var$swiper = new Swiper('.swiper', {
    // Optional parameters
    direction: 'horizontal',
    //   loop: true,
    autoplay: {
        delay: 7000,
        disableOnInteraction: false
    },
    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    // And if we need scrollbar
    scrollbar: {
        el: '.swiper-scrollbar'
    }
});


//# sourceMappingURL=index.6136ada7.js.map
